import { call, params } from './helpers';

// Get all audit trail entries with filtering/pagination
export const getAuditTrails = (payload) =>
	call(`/beta/audit-trails${params(payload)}`);

// Get single audit trail entry
export const getAuditTrail = ({ id }) => call(`/beta/audit-trails/${id}`);

// Get audit trail for specific entity
export const getEntityAuditTrail = ({ entityType, entityId, ...rest }) =>
	call(`/beta/audit-trails/entity/${entityType}/${entityId}${params(rest)}`);

// Get audit trail by request ID
export const getAuditTrailByRequest = ({ requestId }) =>
	call(`/beta/audit-trails/request/${requestId}`);

// Get audit statistics
export const getAuditStats = (payload) =>
	call(`/beta/audit-trails/stats${params(payload)}`);

// Get distinct entity types for filtering
export const getAuditEntityTypes = () => call(`/beta/audit-trails/entity-types`);

// Get distinct actions for filtering
export const getAuditActions = () => call(`/beta/audit-trails/actions`);
